/**
 * The container for various states of the application.
 */
export class AppState {
    public pwaInstalled: boolean = true;
}
